import React, { useState } from "react";
import {
    Typography,
    Empty,
    Input,
    Tag,
} from "antd";
import {
    BankOutlined,
    SearchOutlined,
    CheckCircleFilled,
    StarFilled,
} from "@ant-design/icons";

const { Text, Title } = Typography;
const { Search } = Input;

const PaymentAccountSelector = ({ accounts = [], onSelect, selectedAccountId }) => {
    const [filteredAccounts, setFilteredAccounts] = useState(accounts);
    const [searchText, setSearchText] = useState("");

    // --- 1. Xử lý Tìm kiếm ---
    const handleSearch = (value) => {
        setSearchText(value);
        const filtered = accounts.filter(account =>
            account.name.toLowerCase().includes(value.toLowerCase()) ||
            (account.account_number && account.account_number.toLowerCase().includes(value.toLowerCase())) ||
            (account.bank_name && account.bank_name.toLowerCase().includes(value.toLowerCase())) ||
            (account.account_holder && account.account_holder.toLowerCase().includes(value.toLowerCase()))
        );
        setFilteredAccounts(filtered);
    };

    // --- 2. Format thông tin ---
    // const getAccountTypeInfo = (type) => {
    //     const types = {
    //         'BANK': { color: 'blue', text: 'Ngân hàng', icon: <BankOutlined /> },
    //         'CASH': { color: 'green', text: 'Tiền mặt', icon: <CreditCardOutlined /> },
    //         'E_WALLET': { color: 'purple', text: 'Ví điện tử', icon: <CreditCardOutlined /> },
    //     };
    //     return types[type] || { color: 'default', text: type, icon: <BankOutlined /> };
    // };

    // --- 3. Render Account Card ---
    const renderAccountCard = (account) => {
        const isSelected = selectedAccountId === account.id;
        // const typeInfo = getAccountTypeInfo(account.type);

        return (
            <div
                key={account.id}
                onClick={() => onSelect && onSelect(account)}
                style={{
                    // minWidth: 320,
                    // maxWidth: 320,
                    border: `2px solid ${isSelected ? '#0070D7' : '#E2E8F0'}`,
                    borderRadius: 8,
                    padding: 16,
                    backgroundColor: isSelected ? '#F0F6FD' : 'white',
                    cursor: 'pointer',
                    transition: 'all 0.2s ease',
                    position: 'relative',
                    boxShadow: isSelected ? '0 4px 12px rgba(24, 144, 255, 0.2)' : '0 2px 4px rgba(0,0,0,0.05)',
                }}
                onMouseEnter={(e) => {
                    if (!isSelected) {
                        e.currentTarget.style.borderColor = '#b3d8ff';
                        e.currentTarget.style.boxShadow = '0 4px 8px rgba(0,0,0,0.1)';
                    }
                }}
                onMouseLeave={(e) => {
                    if (!isSelected) {
                        e.currentTarget.style.borderColor = '#E2E8F0';
                        e.currentTarget.style.boxShadow = '0 2px 4px rgba(0,0,0,0.05)';
                    }
                }}
            >
                {/* Selection Badge */}
                {isSelected && (
                    <div style={{
                        position: 'absolute',
                        top: -1,
                        right: -1,
                        backgroundColor: '#0070D7',
                        color: 'white',
                        padding: '4px 12px',
                        borderRadius: '0 6px 0 8px',
                        fontSize: 12,
                        fontWeight: 500,
                        display: 'flex',
                        alignItems: 'center',
                        gap: 4,
                    }}>
                        <CheckCircleFilled />
                        Đã chọn
                    </div>
                )}

                {/* Header */}
                <div style={{ marginBottom: 12 }}>
                    <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 6 }}>
                        <BankOutlined style={{ fontSize: 18, color: '#0070D7' }} />
                        <Text strong style={{ fontSize: 15, flex: 1 }}>
                            {account.name}
                        </Text>
                        {account.is_default && (
                            <StarFilled style={{ color: '#A8681E', fontSize: 14 }} />
                        )}
                    </div>
                    {/* <Tag color={typeInfo.color} icon={typeInfo.icon} size="small">
                        {typeInfo.text}
                    </Tag> */}
                </div>

                {/* Content */}
                {account.type === 'BANK' && (
                    <div style={{ fontSize: 13, lineHeight: 1.8 }}>
                        <div style={{ marginBottom: 6 }}>
                            <Text type="secondary" style={{ fontSize: 12 }}>Ngân hàng</Text>
                            <br />
                            <Text strong>{account.bank_name}</Text>
                        </div>
                        <div className="" style={{ display: 'flex', justifyContent: 'space-between' }}>
                            <div>
                                <Text type="secondary" style={{ fontSize: 12 }}>Số tài khoản</Text>
                                <br />
                                <Text strong style={{ fontFamily: 'monospace' }}>
                                    {account.account_number}
                                </Text>
                            </div>
                            <div>
                                <Text type="secondary" style={{ fontSize: 12 }}>Chủ tài khoản</Text>
                                <br />
                                <Text>{account.account_holder}</Text>
                            </div>

                        </div>
                    </div>
                )}

                {account.type === 'CASH' && (
                    <div style={{ fontSize: 13 }}>
                        <Text type="secondary">Tài khoản tiền mặt</Text>
                    </div>
                )}

                {/* Footer */}
                <div style={{
                    marginTop: 12,
                    paddingTop: 12,
                    borderTop: '1px solid #F1F5F9',
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center'
                }}>
                    <Tag color={account.is_active ? 'green' : 'red'} style={{ margin: 0 }}>
                        {account.is_active ? 'Hoạt động' : 'Ngưng'}
                    </Tag>
                    {account.acqId && (
                        <Text type="secondary" style={{ fontSize: 11 }}>
                            {account.acqId}
                        </Text>
                    )}
                </div>
            </div>
        );
    };

    // Cập nhật filtered khi accounts thay đổi
    React.useEffect(() => {
        setFilteredAccounts(accounts);
    }, [accounts]);

    return (
        <div>
            {/* Header */}
            <div style={{
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                marginBottom: 16
            }}>
                <Title level={5} style={{ margin: 0, display: 'flex', alignItems: 'center', fontWeight: 600 }}>
                    <BankOutlined style={{ marginRight: 8, color: '#0070D7' }} />
                    Chọn Tài Khoản Thanh Toán
                </Title>
                <Text type="secondary" style={{ fontSize: 13 }}>
                    {filteredAccounts.length} / {accounts.length} tài khoản
                </Text>
            </div>

            {/* Search Bar */}
            <div style={{ marginBottom: 16 }}>
                <Search
                    placeholder="Tìm kiếm theo tên, số tài khoản, ngân hàng hoặc chủ tài khoản..."
                    allowClear
                    prefix={<SearchOutlined />}
                    value={searchText}
                    onChange={(e) => handleSearch(e.target.value)}
                    onSearch={handleSearch}
                />
            </div>

            {/* Horizontal Scroll List */}
            <div style={{
                display: 'flex',
                gap: 16,
                // overflowX: 'auto',
                // overflowY: 'hidden',
                paddingBottom: 16,
                scrollbarWidth: 'thin',
                scrollbarColor: '#CBD5E1 #F1F5F9',
                flexDirection: 'column',
                maxHeight: '230px',
                overflowY: 'scroll'
            }}>
                {filteredAccounts.length > 0 ? (
                    filteredAccounts.map(account => renderAccountCard(account))
                ) : (
                    <div style={{ width: '100%', padding: '40px 0' }}>
                        <Empty
                            image={Empty.PRESENTED_IMAGE_SIMPLE}
                            description={
                                searchText
                                    ? "Không tìm thấy tài khoản phù hợp"
                                    : "Chưa có tài khoản nào"
                            }
                        />
                    </div>
                )}
            </div>

            {/* Custom scrollbar styles */}
            <style>{`
                div::-webkit-scrollbar {
                    height: 8px;
                }
                div::-webkit-scrollbar-track {
                    background: #F1F5F9;
                    border-radius: 4px;
                }
                div::-webkit-scrollbar-thumb {
                    background: #CBD5E1;
                    border-radius: 4px;
                }
                div::-webkit-scrollbar-thumb:hover {
                    background: #94A3B8;
                }
            `}</style>
        </div>
    );
};


export default PaymentAccountSelector;